
export enum AnalyticsDoughnutPalette {
    blue="#42a4ef",
    green="#99c140",
    amber="#e7b416",
    red="#cc3232",
    grey="#e5e5e5"
}

export default class AnalyticsDoughnutUtils
{
    public static chartOptions(title: string) {
        return  {
            legend: {
                display: true,
                position: "right"
            },
            tooltips: {
                callbacks: {
                    label: (tooltipItem: any, data:any) => {
                        return data.labels[tooltipItem.index] +' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + '%';
                    }
                }
            },
            title: {
                text: title,
                display: true,
                position: "bottom",
                fontStyle: "light",
                fontColor: "rgba(0,0,0,0.8)"
            }
        };
    }
}